import React, { useState, useEffect, useCallback, useRef } from 'react'
import styled, { css } from 'styled-components'
import ReactPlayer from 'react-player'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  background-color: ${({ theme }) => theme.colors.neutral.black};
`

const Player = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

const Timer = styled.div`
  ${({ theme, timer }) => css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: ${theme.colors.main.secondary};

    &::after {
      position: absolute;
      content: '${timer}';
      font-family: ${theme.fontFamily.heading};
      font-size: ${theme.fontSizes.large};
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: ${theme.colors.neutral.white};
    }
  `}
`

const config = {
  file: {
    hlsOptions: {
      maxBufferSize: 0.5,
      maxBufferLength: 5
    },
    hlsVersion: '0.14.17',
  }
}

function BasicResponsiveVideo({ className, ...props }) {
  const [playTimer, setPlayTimer] = useState(false)
  const [timer, setTimer] = useState(5)
  const timerId = useRef(null)

  const handleEnded = useCallback(() => {
    if (!props.onEnded) return

    setPlayTimer(true)
  }, [setPlayTimer, props.onEnded])

  useEffect(() => {
    if (!playTimer) return
    if (timer === 0) return props.onEnded()

    timerId.current = setInterval(() => setTimer(timer - 1), 1000)

    return () => clearInterval(timerId.current)
  }, [playTimer, setTimer, timer])

  return (
    <Wrapper className={className}>
      <Player
        width="100%"
        height="100%"
        {...props}
        onEnded={handleEnded}
        config={config}
      ></Player>
      {playTimer && <Timer timer={timer}></Timer>}
    </Wrapper>
  )
}

export default BasicResponsiveVideo
